import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { type FC } from 'react';

import { MortgageCalculator } from './MortgageCalculator';
import { trackShowMortgageCalculatorSection } from './internal/tracking/trackShowMortgageCalculatorSection';

export const MortgageCalculatorContainer: FC = () => (
  <ActionAfterViewObserver triggerOnce callback={trackShowMortgageCalculatorSection}>
    <MortgageCalculator />
  </ActionAfterViewObserver>
);
